/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { WazzupIcon } from 'common/icons';
import { InfoBlock } from '../_components';

import { IconEdit, IconEmail, IconPhone } from './icons';

import { staticStyles } from './style';

const ContactsInfoBlock = ({ setUserCrmModalType, setCrmModalType, perms }) => {
  const { phone, email } = useSelector(state => state.crm.users.userData);

  const items = useMemo(
    () => [
      {
        titleId: 'justPhone',
        cell: phone ? (
          <>
            <a className="FieldWithButton" href={`tel:${phone || phone}`}>
              {phone || phone}{' '}
              <div className="FieldWithButton__iconWrapper">
                <IconPhone />
              </div>
            </a>
            {perms.managerWazzupPerm && (
              <div>
                <button type="button" onClick={() => setCrmModalType('sendMessage')}>
                  <div className="FieldWithButton__iconWrapper">
                    <WazzupIcon />
                  </div>
                </button>
              </div>
            )}
            <button type="button" onClick={() => setUserCrmModalType('editPhoneNumber')}>
              <div className="ClientPage__left-icon-edit">
                <IconEdit />
              </div>
            </button>
          </>
        ) : (
          <p>----</p>
        ),
      },
      {
        titleId: 'justEmail',
        cell: email ? (
          <a className="FieldWithButton" href={`mailto:${email}`}>
            {email}
            <div className="FieldWithButton__iconWrapper">
              <IconEmail />
            </div>
            <button type="button" onClick={() => setUserCrmModalType('editEmail')}>
              <div className="ClientPage__left-icon-edit">
                <IconEdit />
              </div>
            </button>
          </a>
        ) : (
          <p>----</p>
        ),
      },
    ],
    [phone, email]
  );
  return (
    <>
      <InfoBlock title="justGeneral" items={items} />

      <style jsx global>
        {staticStyles}
      </style>
    </>
  );
};

ContactsInfoBlock.propTypes = {
  setUserCrmModalType: PropTypes.func.isRequired,
  setCrmModalType: PropTypes.func.isRequired,
  perms: PropTypes.object.isRequired,
};

export default connect(state => ({
  perms: state.user.profile.perms,
}))(ContactsInfoBlock);
